export const SET_TWILIO_TOKEN = 'SET_TWILIO_TOKEN'
export const TELEPHONY_START = 'TELEPHONY_START'
export const TELEPHONY_Close = 'TELEPHONY_Close'
export const TELEPHONY_INCOMING = "TELEPHONY_INCOMING"
export const setTwilioToken = (twilioToken) => async dispatch => {
    dispatch({
        type: SET_TWILIO_TOKEN,
        payload: {
            twilioToken: twilioToken,
        }
    })
}
export const makeCallStart = (params) => async dispatch => {
    dispatch({
        type: TELEPHONY_START,
        payload: {
            params: params,
        }
    })
}
export const callIncoming = () => async dispatch => {
    dispatch({
        type: TELEPHONY_INCOMING,
    })
}


export const dialerModalClose = () => async dispatch => {
    dispatch({
        type: TELEPHONY_Close,
    })
}


// export const telephonyListening = (device) => {
//     device.on("incoming", (args) => {
//         store.dispatch(deviceDidReceiveIncoming(args))
//     })
// }